import Handler from "../Handler";
class DealICMStatusHandler extends Handler {
    // DealICMStatus#{"tourneyId":"mtc2c","timeLeft":8,"participatingPlayers":["myth974454","spruha"],"votes":{"spruha":true}}

    // for watch player
    // DealICMStatus#{“tourneyId”, “timeLeft”, “playersVoted”(int), “playersParticipating”(int)}


    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processDealICMStatusProtocol(receivedData);
    }
}
export default DealICMStatusHandler;
